
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getProductList, delProduct, setProduct } from '@/api/merchant/product'
import editProduct from './editProduct.vue'
import subProduct from './components/subFeeInfo.vue'
import { statusList } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'
import config from './components/cashier.vue'
import { debounce } from 'lodash'

@Component({
  name: 'productList',
  components: {
    editProduct,
    config,
    subProduct
  }
})
export default class extends Vue {
  @Prop({ required: true }) merchant_no!: string
  private merchantProductId: string | null = null
  private listLoading = true
  private dialogVisible: boolean = false
  private productList: any[] = []
  private statusList = statusList
  private productNameList: string[] = []
  get language() {
    return AppModule.language
  }
  // 打开编辑窗口
  private openDialog(merchantProductId: string | null) {
    this.merchantProductId = merchantProductId
    this.dialogVisible = true
    this.productNameList = this.productList.map((item: any) => {
      return item.product_name
    })
  }

  // 打开子产品窗口
  private subFeeVisible: boolean = false
  private subInfo: any = {}
  private openSubDialog(row: any) {
    this.subFeeVisible = true
    this.subInfo = row
  }

  // 在组件中添加防抖处理
  private debouncedGetList = debounce(() => {
    this.getList()
  }, 300)
  private async closeSubFee() {
    this.subFeeVisible = false
    await this.debouncedGetList()
  }

  // 打开产品配置
  private opneProductConfig: boolean = false
  private configInfo: any = null
  private productConfig(row: any) {
    this.configInfo = row
    this.opneProductConfig = true
  }
  private async closeProductConfig() {
    this.opneProductConfig = false
    await this.debouncedGetList()
  }

  private back() {
    this.$emit('close')
  }

  private async closeDialog() {
    await this.debouncedGetList()
  }

  private async getList() {
    try {
      this.listLoading = true
      await getProductList(this.merchant_no).then((res: any) => {
        this.productList = res
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 删除商户产品
  private del(id: number) {
    if (this.language === 'en') {
      this.$confirm('Are you sure to delete it?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
        callback: action => {
          const data: any = {
            merchant_no: this.merchant_no,
            id: id
          }
          if (action === 'confirm') {
            delProduct(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!'
              })
              this.getList()
            })
          }
        }
      })
    }
    if (this.language === 'zh_cn') {
      this.$confirm('确定要删除吗？', {
        confirmButtonText: '是的',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          const data: any = {
            merchant_no: this.merchant_no,
            id: id
          }
          if (action === 'confirm') {
            delProduct(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!'
              })
              this.getList()
            })
          }
        }
      })
    }
    if (this.language === 'zh_tw') {
      this.$confirm('確定要刪除嗎？', {
        confirmButtonText: '是的',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          const data: any = {
            merchant_no: this.merchant_no,
            id: id
          }
          if (action === 'confirm') {
            delProduct(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!'
              })
              this.getList()
            })
          }
        }
      })
    }
  }

  private async setStatus(obj: any) {
    // 保存原来的状态
    const status = obj.status === 0 ? 1 : 0
    const data: any = {
      merchant_no: this.merchant_no,
      id: obj.id,
      status: obj.status
    }
    try {
      await setProduct(data).then((res: any) => {
        this.$message({
          message: 'Save successful!',
          type: 'success'
        })
      })
    } catch (e) {
      obj.status = status
    }
  }

  mounted() {
    this.getList()
  }
}
